import script from "./NotificationsCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsCarousel.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsCarousel.vue?vue&type=style&index=0&id=02bcf999&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02bcf999"]])

export default __exports__